const shouldDisableArticlePrint = (
  userProperties: { canPrintPremiumContent: boolean },
  isArticleLite = false,
): boolean => {
  const { canPrintPremiumContent = false } = userProperties || {};
  if (isArticleLite) {
    return false;
  }
  return !canPrintPremiumContent;
};
export default shouldDisableArticlePrint;
